import { render } from "./ImageEditor.vue?vue&type=template&id=e52222f0"
import script from "./ImageEditor.vue?vue&type=script&lang=ts"
export * from "./ImageEditor.vue?vue&type=script&lang=ts"

import "./ImageEditor.vue?vue&type=style&index=0&id=e52222f0&lang=scss"
script.render = render

export default script